import { useSearchParams } from "react-router";
import type { NotificationFeedItem } from "@situate/contracts/runtime";
import { NotificationsFeedView } from "@/features/deployment-dashboard/notifications/notifications-feed-view";
import { useNotificationsFeed } from "@/features/deployment-dashboard/notifications/hooks/use-notifications-feed";

export function NotificationsFeedContainer() {
  const feed = useNotificationsFeed();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedAlertId = searchParams.get("alertId");

  function handleSelectNotification(notification: NotificationFeedItem): void {
    if (notification.type === "alert") {
      setSearchParams({ alertId: notification.source.id });
    }
  }

  function handleCloseAlert(): void {
    setSearchParams({});
  }

  return (
    <NotificationsFeedView
      {...feed}
      selectedAlertId={selectedAlertId}
      onSelectNotification={handleSelectNotification}
      onCloseAlert={handleCloseAlert}
    />
  );
}
